import useTranslation from '@/hooks/translation'

import Image from 'next/legacy/image'
import MobileDevices from '@/assets/img/downloadapp/mobile-phones.png'
import Icon from '@/assets/img/downloadapp/icon.png'
import PlayStore from '@/assets/img/downloadapp/playstore.png'
import AppStore from '@/assets/img/downloadapp/appstore.png'

import Button from '@/components/ui/button'
import clsx from 'clsx'
import { STORE_ANDROID_URL, STORE_IOS_URL } from '../constants'

export default function DownloadAppPanel({
  className,
  trackingPrefix = 'website',
  noShadow = false,
}) {
  const { t } = useTranslation()
  return (
    <div
      className={clsx(
        'flex flex-col md:flex-row justify-between items-start bg-white rounded-10',
        {
          'shadow-xl border-gray-border': !noShadow,
        },
        className
      )}
    >
      <div className="flex flex-col p-30 gap-30">
        <div className="flex flex-row gap-20 items-start">
          <div className="shrink-0 flex w-60 drop-shadow-md">
            <Image
              className="rounded-5"
              src={Icon}
              objectFit="contain"
              alt="mobile icon"
            />
          </div>
          <h1 className="text-26 leading-[30px] font-bold">
            {t('components.downloadapp.panel.title')}
          </h1>
        </div>
        <div>
          <h2 className="text-22 leading-[28px] font-bold">
            {t('components.downloadapp.panel.subtitle')}
          </h2>
          <p className="text-16 leading-[19px] text-dark-60 mt-10">
            {t('components.downloadapp.panel.description')}
          </p>
        </div>
        <div className="buttons flex flex-row gap-10 justify-center md:justify-start">
          <Button
            className="grow-0 max-w-[166px]"
            href={STORE_ANDROID_URL}
            trackingEventName={`${trackingPrefix}_playstore_banner_clicked`}
            plain
          >
            <Image src={PlayStore} layout="intrinsic" alt="PlayStore" />
          </Button>
          <Button
            className="grow-0 max-w-[166px]"
            href={STORE_IOS_URL}
            trackingEventName={`${trackingPrefix}_appstore_banner_clicked`}
            plain
          >
            <Image src={AppStore} layout="intrinsic" alt="AppStore" />
          </Button>
        </div>
      </div>
      <div className="self-end flex">
        <Image src={MobileDevices} objectFit="contain" alt="mobile app" />
      </div>
    </div>
  )
}
